import styled from 'styled-components'
import { drawStroke, seesawShake } from '../animate'

export const DeleteStyled = styled.svg`
  .stroke {
    stroke: ${props => props.theme};
  }
  .fill {
    fill: ${props => props.theme};
  }
  &.is-animated {
    &:hover {
      .draw-stroke-path {
        stroke-dasharray: 100;
        stroke-dashoffset: 100;
        animation: ${drawStroke} 1s linear forwards;
        &.stroke-path-2 {
          animation: ${drawStroke} 1s 0.2s linear forwards;
        }
        &.stroke-path-3 {
          animation: ${drawStroke} 1s 0.4s linear forwards;
        }
        &.stroke-path-4 {
          animation: ${drawStroke} 1s 0.6s linear forwards;
        }
        &.stroke-path-5 {
          animation: ${seesawShake} 0.6s linear forwards;
        }
      }
    }
  }
`
